<template>
<div>
  <!-- <FeatureDesert v-if="pagename == 'd'" /> -->
  <FeatureDesert v-if="pagename == 'desert'" />
  <FeatureACA v-if="pagename == 'adventurecycling'" />
</div>
</template>

<script>
import FeatureDesert from '@/components/FeatureDesert';
import FeatureACA from '@/components/FeatureACA';
export default {
  name: 'IndexFeature',
  components: {FeatureDesert, FeatureACA},
  props: [],
  data () {
    return {
      pagename: ''
    }
  },
  methods: {
   
  },
  beforeMount() {
    if (this.$route.query.page) {
      this.pagename = this.$route.query.page;
      console.log("pagename is " + this.pagename);
      // window.history.replaceState({}, '', '/feature/' + this.pagename);
      this.$router.replace( {path: '/feature/' + this.pagename});
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>


// WEBPACK FOOTER //
// src/components/IndexFeature.vue